// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__1PF4t","content":"Header_content__2vwGJ","cell":"Header_cell__ySZz5","userNav":"Header_userNav__2Gfek"};